import React from 'react';

const ProfileDropdown = () => (
  <div id="dropdownAvatar" className="z-10 hidden bg-white divide-y divide-gray-100 rounded-lg shadow w-44 dark:bg-gray-700 dark:divide-gray-600">
    <div className="px-4 py-3 text-sm text-gray-900 dark:text-white">
      <div>User Test</div>
      <div className="font-medium truncate">emailExample@email.com</div>
    </div>
    <ul className="py-2 text-sm text-gray-700 dark:text-gray-200" aria-labelledby="dropdownUserAvatarButton">
      <li>
        Dashboard
      </li>
      <li>
        Settings
      </li>
      <li>
        Earnings
      </li>
    </ul>
    <div className="py-2">
      <span className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 dark:hover:bg-gray-600 dark:text-gray-200 dark:hover:text-white">Sign out</span>
    </div>
  </div>
);

export default ProfileDropdown;
